import React from 'react';

import ContentfulImage from '../ContentfulImage';
import * as styles from './EmbeddedEntries.module.scss';

export const simpleMediaGroup = (node, override) => {
  const images = node?.data?.target?.media;
  if (!images) return null;
  return (
    <div className={override ? override : styles.media}>
      {images.map((media, i) => {
        const isSvg = media.file?.contentType === 'image/svg+xml';
        return (
          <ContentfulImage className={[styles.img, isSvg ? 'svg-image' : ''].join(' ')} imageFragment={media} key={i} />
        );
      })}
    </div>
  );
};
